import { iosCartBoldWeight } from 'features/cart/styles';
import { StyleSheet } from 'react-native';

import { primitive } from 'styles/constants';

export const cartActionsStyles = StyleSheet.create({
  removeText: {
    fontSize: 14,
    fontFamily: primitive.fontFamily.$headers,
    ...iosCartBoldWeight,
    color: primitive.$bbqBrown,
  },
});
